import styles from "./SearchCardEmpty.module.css";

function SearchCardEmpty(){
    return (
        <>
        <div className={styles.container}>
            <h2>Invalid Hash</h2>
        </div>
        </>
    )
}

export default SearchCardEmpty;
